import React from 'react';
import { Input as ShadcnInput } from '@/components/ui/shadcn/input';
import { cn } from '@/lib/utils';

export interface InputProps extends React.ComponentProps<typeof ShadcnInput> {}

function Input({ className, ref, ...props }: InputProps) {
  return (
    <ShadcnInput
      ref={ref}
      className={cn(className)}
      {...props}
    />
  );
}

export { Input };
